import { PageBanner } from '@components/PageBanner';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import EatListing from './EatPage/EatListing';
import { selectBannerEat } from './selectors';

interface EatProps {
  park: string;
}

const EatPage = memo(({ park }: EatProps) => {
  const banner = useSelector(selectBannerEat);

  return (
    <main>
      <PageBanner banner={banner} />
      <EatListing park={park} />
    </main>
  );
});

export default EatPage;
